import { Dispatch, SetStateAction } from 'react'
import { ValidationError } from 'yup'
import { getErrorsForFields } from './getErrorsForField'
import { FailedPartialValidationEventDetail } from '../../../../../../MyStichtingOpenHelpers/src/static'

/**
 * @description
 * takes the Event object from a FAILED_PARTIAL event and repopulates the errors array
 * if there are errors related to the provided fieldName or fieldNames
 * @memberof ValidationMessage
 * */
export const onFailedPartialValidation = (
    event: CustomEvent<FailedPartialValidationEventDetail>,
    formId: string,
    fieldNames: string | string[],
    setValidationErrors: Dispatch<SetStateAction<ValidationError[]>>,
) => {
    if (formId !== event.detail.formId || !fieldNames) {
        return
    }
    const fields = typeof fieldNames === 'string' ? [fieldNames] : fieldNames
    const fieldWhereValidated = event.detail.validatedFields.some((validatedField: string) =>
        fields.some((name) => validatedField === name),
    )
    if (!fieldWhereValidated) {
        return
    }
    const errors = getErrorsForFields(event.detail.validationErrors, fieldNames)
    setValidationErrors(errors)
}
